import { createContext, useContext } from 'react';

export interface FmDatedRasterCompareValue {
  reveal: number;
  setReveal: (value: number) => void;
}

export const DatedRasterCompareContext = createContext<FmDatedRasterCompareValue | null>(null);

export function useFmDatedRasterCompare(): FmDatedRasterCompareValue | null {
  return useContext(DatedRasterCompareContext);
}
